module.exports = __webpack_public_path__ + "files/05b4852126734916b8adc78ec328a5f2.svg";